/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_baseHasIn.js
// module id = 225
// module chunks = 3554926981530 35783957827783 231608221292675